import { useMemo } from 'react'
import { useCareerInsightsData } from 'builder/hooks/useCareerInsightsData'

export const usePitchTextParts = () => {
  const { careerInsightsData } = useCareerInsightsData()
  const results = careerInsightsData?.professionalPitchResults

  return useMemo(() => {
    if (!results) {
      return []
    }
    return [results.positioning, results.diff, results.results, results.close]
  }, [results])
}
